module.exports = __webpack_public_path__ + "img/salida.c02a3835.svg";